import gql from "graphql-tag";

export default gql`
  mutation SaveIssuerNotes($issuerId: ObjectID!, $bodyAsJson: JSON, $bodyAsPlainText: String) {
    saveIssuerNotes(issuerId: $issuerId, bodyAsJson: $bodyAsJson, bodyAsPlainText: $bodyAsPlainText) {
      _id
      objectId
      issuerId
      bodyAsJson
      bodyAsPlainText
    }
  }
`;
